<template>
  <div>
    <div style="display: flex; align-items: flex-start">
      <sidebar style="margin-right: 20px; max-width: 200px" />
      <el-card style="width: 100%">
        <div
          slot="header"
          class="clearfix"
        >
          <span>Iktatások</span>
          <el-button
            style="float: right; margin-top: -5px;"
            type="success"
            size="small"
            @click="$router.replace('/docket/dockets/add')"
            icon="el-icon-plus"
            v-can="'docket.create'"
          >
            Új Iktatás
          </el-button>
        </div>
        <div v-loading="loading" style="min-height: 81px;">
          <table-filter
            v-if="config"
            :config="config"
            action="docket/fetchAll"
          />
        </div>
        <list />
        <template v-if="$route.meta.showAddDocketDialog">
          <docket-dialog
            type="add"
          />
        </template>
        <template v-if="$route.meta.showUpdateDocketDialog">
          <docket-dialog
            :docket-id="$route.params.id"
            type="update"
          />
        </template>
        <template v-if="$route.meta.showDocketViewDialog">
          <docket-view-dialog
            :docket-id="$route.params.id"
          />
        </template>
      </el-card>
    </div>
  </div>
</template>
<script>
  import Sidebar from '../../components/docket/Sidebar';
  import List from '../../components/docket/dockets/List';
  import DocketDialog from '../../components/docket/dockets/Dialog';
  import DocketViewDialog from '../../components/docket/dockets/View';
  import TableFilter from '../../components/TableFilter';

  export default {
    components: {
      Sidebar,
      List,
      DocketDialog,
      DocketViewDialog,
      TableFilter,
    },
    data() {
      return {
        config: null,
        loading: false,
      };
    },
    methods: {
      async setConfig() {
        let users = this.$store.getters['user/users'];
        // let partners = await this.$store.dispatch('partner/search');
        let ownCompanies = this.$store.getters['ownCompany/ownCompanies'];
        let docketBooks = await this.$store.dispatch('docketBook/fetchAllWithoutPagination');
        let documentTypes = await this.$store.dispatch('documentType/fetchAllWithoutPagination');
        if(!users.length) {
          await this.$store.dispatch('user/fetchAll');
          users = this.$store.getters['user/users'];
        }
        if(!ownCompanies.length) {
          await this.$store.dispatch('ownCompany/fetchAll');
          ownCompanies = this.$store.getters['ownCompany/ownCompanies'];
        }
        this.config = [
          {
            type: 'text',
            name: 'from_name',
            label: 'Feladó',
            defaultSearch: true,
          },
          {
            type: 'text',
            name: 'to_name',
            label: 'Átvevő',
          },
          {
            type: 'text',
            name: 'reference_number',
            label: 'Hivatkozási szám',
          },
          {
            type: 'select',
            name: 'type',
            options: [
              {
                label: 'Bejövő',
                type: 'in'
              },
              {
                label: 'Kimenő',
                type: 'out'
              },
              {
                label: 'Belső',
                type: 'inner'
              }
            ],
            label: 'Irány',
            labelCallback: type => type && `${type.label}` || '',
            valueKey: 'type',
          },
          {
            type: 'select',
            name: 'creator_user',
            options: users,
            label: 'Rögzítette',
            labelCallback: user => user && `${user.last_name} ${user.first_name} (@${user.username})` || '',
            valueKey: 'id',
          },
          {
            type: 'select',
            name: 'docket_book',
            options: docketBooks,
            label: 'Iktatókönyv',
            labelCallback: db => db && `${db.name}` || '',
            valueKey: 'id',
          },
          {
            type: 'select',
            name: 'document_type',
            options: documentTypes,
            label: 'Irattípus',
            labelCallback: dt => dt && `${dt.name}` || '',
            valueKey: 'id',
          },
          {
            type: 'select',
            name: 'responsible_user',
            options: users,
            label: 'Felelős',
            labelCallback: user => user && `${user.last_name} ${user.first_name} (@${user.username})` || '',
            valueKey: 'id',
          },
          {
            type: 'dateRange',
            name: 'deadline',
            label: 'Dátum',
          },
          {
            type: 'dateRange',
            name: 'responsibleUserDeadline',
            label: 'Felelős határideje',
          },
          // {
          //   type: 'select',
          //   name: 'from',
          //   nameCallback: dt => dt.company ? 'from_partner' : 'from_own',
          //   options: [...partners, ...ownCompanies],
          //   label: 'Honnan',
          //   labelCallback: dt => dt && dt.name || dt.company.name || '',
          // },
          // {
          //   type: 'remote',
          //   name: 'from',
          //   label: 'Honnan',
          //   nameCallback: dt => dt.company ? 'from_partner' : 'from_own',
          //   labelCallback: dt => dt && dt.name || dt.company.name || '',
          //   valueKey: 'id',
          //   remoteSearchParam: 'name',
          //   remoteAction: 'docket/searchPartner',
          // },
          // {
          //   type: 'select',
          //   name: 'to',
          //   nameCallback: dt => dt.company ? 'to_partner' : 'to_own',
          //   options: [...partners, ...ownCompanies],
          //   label: 'Hova',
          //   labelCallback: dt => dt && dt.name || dt.company.name || '',
          // },
        ];
      }
    },
    async mounted() {
      this.loading = true;
      await this.setConfig();
      this.loading = false;
    }
  };
</script>
